import { PaginationTriggerProps } from '../interface/interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faAngleRight, faAnglesLeft, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

export function PaginationTriggers(props: PaginationTriggerProps) {
  return (
    <>
      <div className="flex justify-center mt-10 mb-2 p-3 mx-auto items-center">
        <div className="basis-1/8 hidden">
          <div className="flex items-baseline">
            <span className="pr-2">
              {props.totalRecords <=
              (props.currentPage.pageIndex + 1) * props.currentPage.pageSize
                ? props.totalRecords
                : (props.currentPage.pageIndex + 1) *
                  props.currentPage.pageSize}{' '}
              out of {props.totalRecords} Records
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={() => props.pageHandler(0)}
          className="flex items-center border-r border-solid border-grey-200 bg-white p-3 rounded-l-md hover:bg-secondary-cornflowerblue-50 hover:text-primary-blue-500 text-primary-blue-500"
        >
          <FontAwesomeIcon className="mr-2" icon={faAnglesLeft} /> First
        </button>
        <button
          type="button"
          className="flex items-center border-r border-solid border-grey-200 bg-white p-3 hover:bg-secondary-cornflowerblue-50 hover:text-primary-blue-500 text-primary-blue-500"
          onClick={() =>
            props.currentPage.pageIndex >= 1
              ? props.pageHandler(props.currentPage.pageIndex - 1)
              : null
          }
        >
          <span className="sr-only">Previous</span>
          <FontAwesomeIcon className="mr-2" icon={faAngleLeft} />Prev
        </button>
        <p className="flex items-center border-r border-solid border-grey-200 bg-white p-3 text-primary-blue-500">
          Page {props.currentPage.pageIndex + 1} of{' '}
          {Math.ceil(props.totalRecords / props.currentPage.pageSize)}
        </p>
        <button
          type="button"
          className="flex items-center border-r border-solid border-grey-200 bg-white p-3 hover:bg-secondary-cornflowerblue-50 hover:text-primary-blue-500 text-primary-blue-500"
          onClick={() =>
            props.currentPage.pageIndex + 1 !==
            Math.ceil(props.totalRecords / props.currentPage.pageSize)
              ? props.pageHandler(props.currentPage.pageIndex + 1)
              : null
          }
        >
          <span className="sr-only">Next</span>
          Next<FontAwesomeIcon className="ml-2" icon={faAngleRight} />
        </button>
        <button
          type="button"
          className="flex items-center border-r border-solid border-grey-200 bg-white p-3 rounded-r-md hover:bg-secondary-cornflowerblue-50 hover:text-primary-blue-500 text-primary-blue-500"
          onClick={() =>
            props.pageHandler(
              Math.ceil(props.totalRecords / props.currentPage.pageSize) - 1,
            )
          }
        >
          Last <FontAwesomeIcon className="ml-2 font-light" icon={faAnglesRight} />
        </button>
      </div>
    </>
  );
}
